module.exports = __webpack_public_path__ + "static/media/Jason_Downey.fdeec84d.jpg";